<template>
  <div>
    <v-slide-group
      active-class="success"
      show-arrows
      class="story-banner-card px-3"
      prev-icon="mdi-arrow-left-drop-circle"
      next-icon="mdi-arrow-right-drop-circle"
    >
      <v-slide-item v-for="(item, index) in storyData" :key="index">
        <div
          class="text-center story-item-container"
          @click="openStory(item, index)"
        >
          <div
            class="story-item-img"
            :style="`border-color:${getBorderColor(item, index)}`"
          >
            <v-avatar size="60">
              <v-img class="" :src="item[0].User.Avatar" />
            </v-avatar>
          </div>

          <div
            class="story-item-text text-wrap"
            :style="`color:${getBorderColor(item, index)}`"
          >
            {{ item[0].User.FullName }}
          </div>
        </div>
      </v-slide-item>
      <template v-slot:next>
        <v-icon color="defaultColor"> mdi-arrow-right-drop-circle </v-icon>
      </template>
      <template v-slot:prev>
        <v-icon color="defaultColor"> mdi-arrow-left-drop-circle </v-icon>
      </template>
    </v-slide-group>


        <Stories
          :stories="newData"
          :showInnerContent="false"
          :showOuterContent="false"
          @closeStories="openModelStory = false"
          @setCurrentIndex="(n) => this.setCurrentIndex(n)"
          @сurrentImageEnd="(n) => this.сurrentImageEnd(n)"
          @сurrentAllImagesEnd="(n) => this.сurrentAllImagesEnd(n)"
          @viewedStory="(n) => this.getViewedStory(n)"
          :currentIndex="currentIndex"
          :duration="7000"
          :visible="openModelStory"
        >
          <template v-slot:outerContent="{ story }">
            <div v-if="story.info" class="story-info">
              <ul class="actions">
                <li class="actions__item">
                  <v-icon color="defaultColor">
                    mdi-arrow-left-drop-circle
                  </v-icon>
                  <div class="actions__text">{{ story.info.comment }}</div>
                </li>
                <li class="actions__item">
                  <v-icon color="defaultColor">
                    mdi-arrow-left-drop-circle
                  </v-icon>
                </li>
              </ul>
            </div>
          </template>
        </Stories>

  </div>
</template>
<script>
import StoryService from "../../services/StoryService";
import Stories from "./Stories.vue";
import moment from "moment";
//import Stories from "vue-stories-instagram";

export default {
  props: {
    userId:{
      type:String,
      require:false
    },
    isProfileStories:{
      type:Boolean,
      require:false,
      default:false,
    }
  },
  components: {
    Stories,
  },
  data() {
    return {
      storyData: [],
      page: 1,
      pageSize: 100,
      currentIndex: 0,
      openModelStory: false,

      newData: [],
    };
  },
  beforeMount() {
    if(this.isProfileStories){
      //Profile pinned stories
      this.getStories(true, this.page, this.pageSize, this.userId)
    }else{
      //Global Stories
      this.getStories();
    }
    
  },
  mounted() {},
  methods: {
    getStories(isPinned = false, page = this.page, pageSize = this.pageSize, userId = '') {
      StoryService.getStories(isPinned, page, pageSize, userId)
        .then((res) => {
          if (this.page != 1) {
            this.storyData = [...this.storyData, ...res.data];
          } else {
            this.storyData = res.data;
            this.setStoryData();
          }
        })
        .catch((err) => {
          console.log("err", err);
          showError(err);
        })
        .then(() => {});
    },

    setStoryData() {
      let newData = [];
      this.storyData.forEach((elementOne, indexOne) => {
        let obj = {
          images: [],
          username: "",
          picture: "",
          //time: "",
          info: {},
          prototype: {},
          department: "",
          indexOne: indexOne,
        };
        elementOne.forEach((elementTwo, indexTwo) => {
          let imageObj = {
            url: elementTwo.Media.LocalUrl,
            viewed: false,
            duration: elementTwo.Duration,
            type: elementTwo.Media.MimeType == "video/mp4" ? "video" : "image",
            id: elementTwo.Id,
            text: elementTwo.Text,
            textColor: elementTwo.TextColor,
            textLocation: elementTwo.TextLocation,
            textType: elementTwo.TextType,
            isPinned: elementTwo.IsPinned,
            time: moment(elementTwo.CreatedAt).locale("tr").fromNow(),
            indexTwo: indexTwo,
          };
          obj.images.push(imageObj);
          if (indexTwo == 0) {
            obj.username = elementTwo.User.FullName;
            obj.picture = elementTwo.User.Avatar;
            //obj.time = moment(elementTwo.CreatedAt).locale("tr").fromNow();
            obj.department = elementTwo.User.Department;
            obj.viewList = elementTwo.ViewList;
            (obj.viewCount = elementTwo.ViewCount),
              (obj.myStory =
                elementTwo.UserId == this.$store.state.userId ? true : false);
          }
        });
        newData.push(obj);
      });
      this.newData = newData;
      console.log("new data :", this.newData);
    },

    openStory(item, index) {
      this.currentIndex = index;
      setTimeout(() => {
        this.openModelStory = true;
      }, 100);
    },

    сurrentAllImagesEnd(n) {
      this.currentIndex = -1;
    },

    сurrentImageEnd(n) {
      //console.log('сurrentImageEnd : ', n)
    },

    getViewedStory(n){
      this.storyData[n.indexOne][n.indexTwo].ViewStatus = true
      this.getBorderColor(this.storyData[n.indexOne])
    },

    getBorderColor(item, index) {
      let statuArr = item.filter(x => x.ViewStatus == false)
      if (statuArr.length > 0) {
        return "#102A62";
      } else {
        return "rgba(16, 42, 98, 0.6)";
      }
    },

    setCurrentIndex(n){
      console.log('current emit : ', n)
      this.currentIndex = n
    }
  },
  computed: {},
};
</script>
<style>
.story-banner-card > .v-slide-group__next,
.v-slide-group__prev {
  min-width: 40px !important;
}
</style>
